import React from 'react';
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Font,
    Image
} from '@react-pdf/renderer';
import logo from '../../../../Assets/Images/peicar.png';
import signature from '../../../../Assets/Images/purchaseOrder/FirmaAbraam.png';
import background from '../../../../Assets/Images/purchaseOrder/LogoMembretado.png';

// Definición de estilos
const styles = StyleSheet.create({
    page: {
        padding: 40,
        fontSize: 10,
        fontFamily: 'Helvetica',
        color: '#333',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    logo: {
        width: 100, // Ajusta el tamaño según sea necesario
    },
    titleSection: {

        marginTop: 15,
        textAlign: 'center',
    },
    mainTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#4a5568',
        textTransform: 'uppercase',
    },
    infoGraySection: {
        borderBottom: 1,
        borderBottomColor: '#4a5568',
        paddingBottom: 10,
        marginTop: 10,
        fontSize: 9,
        color: '#23b56e',
        lineHeight: 1.5,
        textAlign: 'center',
    },
    section: {
        marginTop: 15,
    },
    sectionTitle: {
        fontSize: 11,
        fontWeight: 'bold',
        backgroundColor: '#f7fafc',
        padding: 5,
        color: '#32b8df',
        borderLeft: 3,
        borderLeftColor: '#23b56e',
        marginBottom: 8,
    },
    row: {
        flexDirection: 'row',
        borderBottomWidth: 0.5,
        borderBottomColor: '#edf2f7',
        paddingVertical: 4,
    },
    label: {
        width: '30%',
        fontWeight: 'bold',
        color: '#2d3748',
    },
    value: {
        width: '70%',
    },
    textBlock: {
        marginTop: 5,
        lineHeight: 1.4,
        textAlign: 'justify',
    },
    footer: {
        borderTop: 1,
        borderBottomColor: '#4a5568',
        paddingTop: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 10,
    },
    signatureArea: {
        marginTop: 0,
        alignItems: 'center',
        width: '200pt',
        marginBottom: -20,
        position: 'relative',
    },
    signatureImage: {
        width: 180,
        position: 'absolute',
        top: -90,
    },
    signatureLine: {
        borderTopWidth: 1,
        borderTopColor: '#000',
        width: '100%',
        marginTop: 40,
        marginBottom: 5,
    },
    contactInfo: {
        position: 'absolute',
        bottom: 0,
        left: 40,
        right: 40,
        fontSize: 9,
        textAlign: 'center',
        color: '#718096',
    },
    backgroundImage: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        width: '100vw',
        height: 'auto',
        zIndex: -1,
    }
});

const PurchaseOrderPDF = ({ persona, contactName, agencyName, date }) => {

    // Extracción de datos con valores por defecto
    const brand = persona?.infoBudget?.vehicle?.brand || 'N/A';
    const model = persona?.infoBudget?.vehicle?.model || 'N/A';
    // Usamos descripción como versión, o concatenamos si es necesario. El usuario mapeó "M50i 2026" a versión.
    // Si la descripción es muy larga, tal vez deberíamos recortarla o usar otro campo.
    // Por ahora usaremos descripción como el candidato más probable para "Versión" detallada.
    const year = persona?.infoBudget?.vehicle?.year || '';

    const version = `${persona?.infoBudget?.vehicle?.description || 'N/A'} - ${year}`;
    const engine = persona?.infoBudget?.engine || 'N/A';
    const condition = persona?.infoBudget?.vehicle?.type || 'Nuevo';
    const plate = persona?.infoBudget?.state_plate_id || 'En trámite';
    const price = persona?.infoBudget?.price
        ? new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(persona.infoBudget.price)
        : '$0.00 MXN';
    const userName = persona?.name || 'Cliente';
    const formattedDate = (date ? new Date(date) : new Date()).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Image src={background} style={styles.backgroundImage} fixed />

                {/* Encabezado */}
                <View style={styles.header}>
                    <Image src={logo} style={styles.logo} />
                </View>

                <View>

                    <View style={styles.titleSection}>
                        <Text style={styles.mainTitle}>ORDEN DE COMPRA PEICAR / Conduce Capital S.A.P.I. de C.V.</Text>
                    </View>

                    <View style={styles.infoGraySection}>
                        <Text>
                            <Text style={{ fontWeight: 'bold' }}>Fecha:</Text> {formattedDate} | <Text style={{ fontWeight: 'bold' }}>Dirigido a:</Text> {contactName || 'Encargado'} | <Text style={{ fontWeight: 'bold' }}>{agencyName || 'Agencia'}</Text>
                        </Text>
                    </View>
                </View>

                {/* 1. Unidad Solicitada */}
                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>1. UNIDAD SOLICITADA</Text>
                    <View style={styles.row}><Text style={styles.label}>Marca:</Text><Text style={styles.value}>{brand}</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Modelo:</Text><Text style={styles.value}>{model}</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Versión:</Text><Text style={styles.value}>{version}</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Tipo de motor:</Text><Text style={styles.value}>{engine}</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Condición:</Text><Text style={styles.value}>{condition}</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Placas:</Text><Text style={styles.value}>{plate} (tramitadas por PEICAR)</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Seguro:</Text><Text style={styles.value}>Tramitado por PEICAR</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Precio unidad:</Text><Text style={styles.value}>{price} (IVA incluido)</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Usuario:</Text><Text style={styles.value}>{userName}</Text></View>
                </View>

                {/* 2. Datos de Facturación */}
                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>2. DATOS DE FACTURACIÓN</Text>
                    <View style={styles.row}><Text style={styles.label}>A nombre de:</Text><Text style={styles.value}>Conduce Capital S.A.P.I. de C.V. (PEICAR)</Text></View>
                    <View style={styles.row}><Text style={styles.label}>RFC:</Text><Text style={styles.value}>CCA2308224G3</Text></View>
                    <View style={styles.row}>
                        <Text style={styles.label}>Domicilio:</Text>
                        <Text style={styles.value}>Onimex lote 5 casa 32, Col. El Potrero, Ecatepec, Estado de México, C.P. 55090</Text>
                    </View>
                    <View style={styles.row}><Text style={styles.label}>Uso CFDI:</Text><Text style={styles.value}>103 - Equipo de transporte</Text></View>
                    <View style={styles.row}><Text style={styles.label}>Método pago:</Text><Text style={styles.value}>PPD - Pago en parcialidades o diferido</Text></View>
                </View>

                {/* 3. Condiciones */}
                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>3. CONDICIÓN PARA LIQUIDACIÓN</Text>
                    <Text style={styles.textBlock}>
                        La liquidación total de la unidad queda sujeta a la firma del contrato de arrendamiento por parte del cliente {userName}. Una vez firmados los documentos, PEICAR procederá con la disposición y pago final a la agencia.
                    </Text>
                </View>

                {/* 4. Trámites */}
                <View style={styles.section}>
                    <Text style={styles.sectionTitle}>4. TRÁMITES INCLUIDOS POR PEICAR</Text>
                    <Text style={styles.textBlock}>• Gestión de placas CDMX</Text>
                    <Text style={styles.textBlock}>• Seguro por todo el plazo del arrendamiento</Text>
                    <Text style={styles.textBlock}>• Gestorías correspondientes</Text>
                </View>

                {/* Firma y Autorización */}
                <View style={styles.footer}>
                    <View style={styles.signatureArea}>
                        <Text>Atentamente,</Text>
                        <Text style={{ fontWeight: 'bold', marginTop: 5 }}>Equipo PEICAR</Text>
                    </View>


                    <View style={styles.signatureArea}>
                        <Text style={{ fontSize: 9, marginBottom: 5 }}>Autoriza</Text>
                        <Image src={signature} style={styles.signatureImage} />
                        <View style={styles.signatureLine} />
                        <Text style={{ fontWeight: 'bold' }}>Abraam Bonilla Sagahon</Text>
                        <Text style={{ fontSize: 8 }}>Representante Legal</Text>
                        <Text style={{ fontSize: 8 }}>Conduce Capital SAPI de C.V.</Text>
                    </View>
                </View>



            </Page>
        </Document>
    )
};

export default PurchaseOrderPDF;
